"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var AccountSettingsForm_module_css_1 = __importDefault(require("../AccountSettingsForm.module.css"));
var SimpleSSO = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { id: AccountSettingsForm_module_css_1.default.formContainer },
            react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.title },
                react_1.default.createElement("span", null, t("Single Sign-On (SSO)"))),
            react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputContainer },
                react_1.default.createElement("span", null, t("Contact NordicScreen support to activate advanced SSO."))))));
};
exports.default = SimpleSSO;
